export enum RoomType {
    LIVING_ROOM = 1,
    BEDROOM = 2,
    DINING_ROOM = 3,
    ROOM = 4,
    OFFICE = 5,
    KITCHEN = 6,
    BATHROOM = 7,
    WC = 8,
    CORRIDOR = 9,
    STAIRS = 10,
    WARDROBE = 11,
    UTILITY_ROOM = 12,
    ENTRESOL = 13,
    ATTIC = 14,
    LIVING_ROOM_WITH_KITCHENETTE = 15
}
export enum FormRoomType {
    LIVING_ROOM = "r_1",
    BEDROOM = "r_2",
    DINING_ROOM = "r_3",
    ROOM = "r_4",
    OFFICE = "r_5",
    KITCHEN = "r_6",
    BATHROOM = "r_7",
    WC = "r_8",
    CORRIDOR = "r_9",
    STAIRS = "r_10",
    WARDROBE = "r_11",
    UTILITY_ROOM = "r_12",
    ENTRESOL = "r_13",
    ATTIC = "r_14",
    LIVING_ROOM_WITH_KITCHENETTE = "r_15"
}

export enum AdditionalAreaType {
    BALCONY = 1,
    LOGGIA = 2,
    TERRACE = 3,
    GARDEN = 4
}

export enum AdditionalAreaTypeNames {
    "balkon",
    "loggia",
    "taras",
    "ogród"
}
// actually ids for additional areas are 1, 2, etc... but they need to be on the same list as rooms and ids would overlap
export enum FormAdditionalAreaType {
    BALCONY = "as_1",
    LOGGIA = "as_2",
    TERRACE = "as_3",
    GARDEN = "as_4"
}
